const PRESET_LABELS = {
  light: 'Mittleres Starkregenereignis',
  heavy: 'Extremes Starkregenereignis',
};

const formatAmount = (amount) => Number(amount).toLocaleString('de-DE', { maximumFractionDigits: 1 });

// Radio label of a rain preset, with the rain the backend will actually use
// for this region. `presets` is the response of /get_rain_presets.
export const rainPresetLabel = (name, presets) => {
  const preset = presets && presets[name];
  if (!preset) return PRESET_LABELS[name];
  const amount = `${formatAmount(preset.rain_amount)} mm/h`;
  if (preset.source === 'kostra') {
    return `${PRESET_LABELS[name]} (${preset.return_period}-jährlich nach KOSTRA-DWD: ${amount})`;
  }
  return `${PRESET_LABELS[name]} (${amount})`;
};

export const usesKostra = (presets) => Boolean(presets && presets.light && presets.light.source === 'kostra');
